import { CampanhaSelect } from './campanha-select';

export class AreaCampanhaSelect {
    id: number;
    nome: string;
    private _campanhas: CampanhaSelect[];

    constructor(id: number, nome: string) {
        this.id = id;
        this.nome = nome;
        this._campanhas = [];
    }

    /** Campanhas da área */
    get campanhas(): CampanhaSelect[] {
        return this._campanhas;
    }

    /** Adiciona uma campanha à área */
    addCampanha(campanha: CampanhaSelect) {
        this._campanhas.push(campanha);
    }

    /** Verifica se a área possui a campanha informada */
    hasCampanha(idCampanha: number): boolean {
        const campanha = this.findCampanha(idCampanha);
        return campanha != null && campanha !== undefined;
    }

    /** Procura a campanha informada na área */
    findCampanha(idCampanha: number): CampanhaSelect {
        return this._campanhas?.find(campanhaFilter => campanhaFilter.id === idCampanha);
    }
}

/** Obtem a área da campanha no array de áreas de campanhas através do id informado */
export function findAreaCampanha(areasCampanhas: AreaCampanhaSelect[], idArea: number): AreaCampanhaSelect {
    if (!areasCampanhas) {
        return null;
    }
    return areasCampanhas?.find(areaFilter => areaFilter.id === idArea);
}

/** Cria os options do select agrupando as campanhas pelas suas áreas */
export function createAreasCampanhasSelect(campanhas: CampanhaSelect[]): AreaCampanhaSelect[] {
    const areasCampanhas = [];
    if (!campanhas) {
        return;
    }

    // Campanhas pesquisadas
    for (let i = 0; i < campanhas.length; i++) {
        const campanha = campanhas[i];

        // Obtendo a éra da campanha
        let area = findAreaCampanha(areasCampanhas, campanha.idArea);

        // Se não encontrar a área no array de áreas, então criamos ele através da campanha
        if (!area) {
            area = new AreaCampanhaSelect(campanha.idArea, campanha.nomeArea);
            areasCampanhas.push(area);
        }

        // Adicionando a campanha à sua área
        area.addCampanha(campanha);
    }

    return areasCampanhas;
}
